module.exports = __webpack_public_path__ + "static/media/cheryl-cole-win.50272e65.jpg";